import { useActiveBrandConfig } from '@/brand';

export const useAvailableLocales = () => {
  const {
    i18n: { locales },
  } = useActiveBrandConfig();

  return locales;
};
